var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBounceFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      animation: "1.11111s linear 0.1s 1 normal forwards running bounce-in"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M45.5 8.2l-29.4 17c-2.8 1.6-4.5 4.6-4.5 7.8v34c0 3.2 1.7 6.2 4.5 7.8l29.4 17c2.8 1.6 6.2 1.6 9 0l29.4-17c2.8-1.6 4.5-4.6 4.5-7.8V33c0-3.2-1.7-6.2-4.5-7.8l-29.4-17c-2.8-1.6-6.2-1.6-9 0z",
    style: {
      fill: "rgb(59, 67, 104)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      animation: "1.11111s linear 0.185185s 1 normal forwards running\r\n              bounce-in"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 68.5l37-37 M68.5 68.5l-37-37",
    strokeMiterlimit: 10,
    strokeWidth: 10,
    stroke: "#fff",
    fill: "none",
    style: {
      stroke: "#e15b64"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceFail);
export default __webpack_public_path__ + "static/media/BounceFail.d59aaf5b.svg";
export { ForwardRef as ReactComponent };